
import { CheckCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

interface StepIndicatorProps {
  steps: readonly string[];
  currentStep: number;
}

export function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="mb-12">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <React.Fragment key={step}>
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-300",
                    currentStep === index
                      ? "bg-teal-600 text-white shadow-lg scale-110 ring-4 ring-teal-100"
                      : currentStep > index
                      ? "bg-teal-100 text-teal-600"
                      : "bg-gray-100 text-gray-400"
                  )}
                >
                  {currentStep > index ? (
                    <CheckCircle className="h-5 w-5" />
                  ) : (
                    index + 1
                  )}
                </div>
                <span className={cn(
                  "mt-2 text-sm font-medium",
                  currentStep >= index ? "text-gray-900" : "text-gray-400"
                )}>
                  {step}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={cn(
                    "flex-1 h-1 mx-4 rounded transition-all duration-500",
                    currentStep > index
                      ? "bg-teal-600"
                      : "bg-gray-200"
                  )}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}